import {
    EuiButtonIcon,
    EuiDescriptionList,
    EuiDescriptionListDescription,
    EuiDescriptionListTitle,
    EuiFlexGrid,
    EuiFlexGroup,
    EuiFlexItem,
    EuiFormRow,
    EuiHorizontalRule,
    EuiText,
    EuiTextArea,
} from "@elastic/eui";
import React from "react";
import { FormattedMessage } from "react-intl";
import AbstractDate from "../../../shared/entity/components/AbstractFormField/fields/AbstractDate";
import AbstractDropdown from "../../../shared/entity/components/AbstractFormField/fields/AbstractDropdown";
import AbstractFile from "../../../shared/entity/components/AbstractFormField/fields/AbstractFile";
import DropoffsForm from "../../../trips/components/shared/DropoffsForm";
import * as S from "../../style";
import moment from "moment";
import AbstractCheckbox from "../../../shared/entity/components/AbstractFormField/fields/AbstractCheckbox";
import { useSelector } from "react-redux";
import { getUserRoles } from "modules/auth/slice";


const extractSelectedOption = (selectedValue) => (selectedValue ? [selectedValue] : []);

const TripForm = ({
    formValues,
    supplier,
    organizationId,
    isManual,
    errors,
    register,
    control,
    tripFormFields,
    onListChange,
    onDateChange,
    onTripPointsChange,
    onTextAreaChange,
    onCheckboxChange,
    onFileUpload,
    onFileRemove,
    onCreateEntity,
    onSelectChange,
    branchLocation,
}) => {
    const attachmentField = tripFormFields.find((f) => f.name === "tripAttachments");
    const notesField = tripFormFields.find((f) => f.name === "tripNotes");

    const getCurrentUserRoles = useSelector(getUserRoles());


    const isUserSupplierPartner = getCurrentUserRoles?.includes("supplier_partner_account_manager")
    return (
        <S.TripFormWrapper>
            <div className="create-order__section">
                <h3 className="create-order__title--required">
                    <FormattedMessage id="trip-form.details-section-title" />
                </h3>
                <EuiFlexGrid
                    className="create-order__fields-wrapper"
                    gutterSize="xl"
                    columns={1}
                >
                    {tripFormFields.map((field) => {
                        const disableSupplierRelation =
                            (field.name === "driver" || field.name === "truck") &&
                            !(supplier && supplier.value);

                        switch (field.type) {
                            case "list":
                                return (
                                    <EuiFlexItem
                                        key={field.name}
                                        className="form__field-wrapper"
                                    >
                                        <AbstractDropdown
                                            errors={errors}
                                            register={register}
                                            entityOptions={
                                                field.name === "supplier" && organizationId && isUserSupplierPartner ? {
                                                    ...field,
                                                    url: `/${field.entityName}`,
                                                    filterResource: `filter[organization_id]=${organizationId}`,
                                                } :
                                                    supplier &&
                                                        (field.name === "driver" || field.name === "truck")
                                                        ? {
                                                            ...field,
                                                            url: `/${field.entityName}`,
                                                            filterResource: `filter[supplierId]=${supplier.value}`,
                                                        }
                                                        : field
                                            }
                                            onValueChange={onListChange}
                                            selectedOptions={extractSelectedOption(
                                                formValues[field.name]
                                            )}
                                            isDisabled={disableSupplierRelation}
                                            options={field.data}
                                        />

                                        {field.createOptions && !disableSupplierRelation && (
                                            <EuiButtonIcon
                                                iconType="plus"
                                                onClick={() => onCreateEntity(field)}
                                                aria-label={`Create ${field.createOptions.displayName}`}
                                                size="m"
                                                className="field-wrapper__create-btn"
                                            />
                                        )}
                                    </EuiFlexItem>
                                );
                            case "dateAndTime":
                                return (
                                    <EuiFlexItem key={field.name}>
                                        <AbstractDate
                                            options={field}
                                            errors={errors}
                                            entityObject={{
                                                [field.name]: formValues[field.name]
                                                    ? moment(formValues[field.name])
                                                    : null,
                                            }}
                                            onDateChange={(date) => onDateChange(field.name, date)}
                                            register={register}
                                            control={control}
                                        />
                                    </EuiFlexItem>
                                );
                            case "checkbox":
                                return (
                                    <EuiFlexItem key={field.name}>
                                        <AbstractCheckbox
                                            options={field}
                                            isChecked={false}
                                            errors={errors}
                                            register={register}
                                            onChange={(value) =>
                                                onCheckboxChange(field.name, value)
                                            }
                                        />
                                    </EuiFlexItem>
                                );
                            default:
                                return "";
                        }
                    })}

                    <EuiFlexItem>
                        <EuiDescriptionList>
                            <EuiDescriptionListTitle
                                className={
                                    formValues.isPointsValid === false
                                        ? "trip-points__label--invalid"
                                        : ""
                                }
                            >
                                <small>
                                    <FormattedMessage id="trip-form.locations-section-title" />
                                </small>
                            </EuiDescriptionListTitle>
                            <EuiDescriptionListDescription className="trip-points__input">
                                <DropoffsForm
                                    selectedDropOffs={formValues.tripPoints}
                                    tripType={formValues.tripType}
                                    onChange={onTripPointsChange}
                                    organizationId={+organizationId}
                                    branchLocation={branchLocation}
                                />
                                {formValues.branch &&
                                    !formValues.branch.value &&
                                    formValues.isPointsValid === false && (
                                        <EuiText
                                            size="xs"
                                            color="danger"
                                        >
                                            {!formValues.tripPoints[0].location.id &&
                                                "Dropoff address is required"}
                                        </EuiText>
                                    )}
                            </EuiDescriptionListDescription>
                        </EuiDescriptionList>
                    </EuiFlexItem>
                </EuiFlexGrid>
            </div>

            <EuiHorizontalRule margin="none" />

            <EuiFlexGroup
                gutterSize="none"
                justifyContent="spaceBetween"
            >
                <EuiFlexItem className="create-order__sub-section border-right">
                    <h3>
                        <FormattedMessage id="trip-form.attachments-section-title" />
                    </h3>
                    <AbstractFile
                        options={attachmentField}
                        errors={errors}
                        onFileUpload={onFileUpload}
                        onFileRemove={onFileRemove}
                        selectedFiles={formValues[attachmentField.name]}
                    />
                </EuiFlexItem>
                <EuiFlexItem className="create-order__sub-section">
                    <h3>
                        <FormattedMessage id="trip-form.notes-section-title" />
                    </h3>
                    <EuiFormRow
                        fullWidth
                        label={notesField.label}
                        key={notesField.name}
                        id={notesField.name}
                        helpText={notesField.helpText}
                    >
                        <EuiTextArea
                            placeholder="Text goes here..."
                            name={notesField.name}
                            inputRef={register({ required: false })}
                            onChange={(e) => onTextAreaChange(e.target.name, e.target.value)}
                            resize="none"
                            fullWidth
                        />
                    </EuiFormRow>
                </EuiFlexItem>
            </EuiFlexGroup>
        </S.TripFormWrapper>
    );
};

export default TripForm;
